<template>

<div class="textbox" :class="{'is-flag': flag, 'is-numeric': input.numeric, 'is-long': input.long, 'is-multiline': input.layout.lines}">

	<input v-if="!input.layout.lines" :type="(input.numeric) ? 'text' : 'text'" class="textbox-input" :placeholder="input.text.placeholder" v-model="value" v-on:keydown="onKeyDown" v-on:keyup="onKeyUp" />
	<textarea v-if="input.layout.lines" :rows="input.layout.lines" class="textbox-input" :placeholder="input.text.placeholder" v-model="value" v-on:keyup="onKeyUp"></textarea>

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	data: function() {

		return {
			value: ''
		}

	},

	created: function() {

		this.value = (this.input.manual) ? '' : this.values[this.input.variable]

	},

	methods: {

		onKeyDown: function(e) {

			if (this.input.numeric) {

				if (!this.$_.contains(['1','2','3','4','5','6','7','8','9','0','Backspace', 'Delete'], e.key)) {

					e.preventDefault()

				}

			}

		},

		onKeyUp: function() {

			if (this.input.manual) {

				this.$emit('change', this.value)

			} else {

				this.$store.dispatch('set', {
					input: this.input.id,
					variable: this.input.variable, 
					value: this.value
				})

			}

		}

	}

}

</script>

<style scoped>

.textbox-input {
	background-color: #f6f6f6;
	height: 48px;
	line-height: 48px;
	padding: 0px 20px;
	border-radius: 24px;
	font-size: 20px;
	width: 100%;
	color: #343434;
	font-weight: 100;
	border: 2px solid #f6f6f6;
	transition: all 300ms ease-in-out;
}

.textbox.is-numeric .textbox-input {
	text-align: center;
}

.textbox.is-multiline .textbox-input {
	height: auto;
	line-height: 24px;
	padding: 18px 20px;
	resize: none;
}

.is-desktop .textbox.is-long {
	width: 400px;
}

.is-desktop .textbox.is-numeric {
	width: 100px;
}

.is-tablet .textbox.is-long {
	width: calc(100vw - 400px);
}

.is-desktop .textbox.is-numeric {
	width: 100px;
}

.is-mobile .textbox-input {
	height: 36px;
	font-size: 14px;
	border-radius: 16px;
	width: 100%;
	line-height: 32px;
}

.textbox.is-flag .textbox-input {
	border-color: #ee7173;
}

</style>